import { DispatcherEvent } from '@carvana/merch-native';
import { useCallback, useContext, useEffect } from 'react';
import { shareData as defaultShareData } from '~/constants/vdp/shareData';
import { useIsNative } from '~/context/common/DeviceContext';
import ShareContext from '~/context/common/ShareContext';
import { sendMessageToNative } from '~/native/vdp/dispatchers';
import { shareOrCopyUrl } from '~/utilities';
import { generateErrorLogger } from '~/utilities/loggers';

export type ShareData = {
  title?: string;
  text?: string;
};

export default function useShareLink(shareData: ShareData = defaultShareData) {
  const isNative = useIsNative();
  const { isShareNotificationVisible, setShareNotificationVisible } =
    useContext(ShareContext);

  const shareLink = useCallback(() => {
    if (isNative) {
      sendMessageToNative(DispatcherEvent.Share, {});
    } else {
      shareOrCopyUrl(shareData)
        .then(() => {
          setShareNotificationVisible(true);
        })
        .catch(generateErrorLogger('Share link', { shareData }));
    }
  }, [isNative, setShareNotificationVisible, shareData]);

  useEffect(() => {
    if (!isShareNotificationVisible) return () => {};
    const t = setTimeout(() => setShareNotificationVisible(false), 2000);

    return () => {
      clearTimeout(t);
    };
  }, [isShareNotificationVisible, setShareNotificationVisible]);

  return shareLink;
}
